<style scoped>

</style>
<template>
    <div :class="{'color-error': recruit_need.del}">
        <div>{{recruit_need.uid}}</div>
        <div v-if="recruit_need.del">已废弃</div>
    </div>
</template>
<script>
    export default {
        props: {
            recruit_need: {
                type: Object,
                required: true
            }
        },
        data(){
            return {
                //
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            //
        }
    }
</script>
